import {Component, Inject, Input, OnInit} from '@angular/core';
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {ModalAdicionarHorarioComponent} from "./modal-adicionar-horario.component";
import {GridHorariosEditService} from "../../superadmin/cad-empresas/grid-horarios-edit-service";
import {ModalConfirmacaoComponent} from "./modal-confirmacao.component";
import {ConstantsService} from "../../fidelidade/ConstantsService";

declare var _;
declare var moment;

@Component({
  selector: 'app-cad-horariosfuncionamentonova',
  templateUrl: './cad-horariosfuncionamentonova.component.html',
  styleUrls: ['./cad-horariosfuncionamentonova.component.scss']
})
export class CadHorariosfuncionamentoNovoComponent implements OnInit {
  @Input() empresa: any = {};

  diasDaSemana = [
    {dia: 1, descricao: 'Segunda', abreviacao: 'Seg'},
    {dia: 2, descricao: 'Terça', abreviacao: 'Ter'},
    {dia: 3, descricao: 'Quarta', abreviacao: 'Qua'},
    {dia: 4, descricao: 'Quinta', abreviacao: 'Qui'},
    {dia: 5, descricao: 'Sexta', abreviacao: 'Sex'},
    {dia: 6, descricao: 'Sábado', abreviacao: 'Sáb'},
    {dia: 0, descricao: 'Domingo', abreviacao: 'Dom'}
  ];

  servicosBase = [
    {id: 'site', descricao: 'Pedidos para delivery', label: 'Delivery'} ,
    {id: 'siteretirada', descricao: 'Pedidos para retirada', label: 'Retirada'} ,
    {id: 'presencial', descricao: 'Pedidos mesas', label: 'Presencial'},
    {id: 'ifood', descricao: 'Pedidos recebidos via iFood', label: 'iFood'}
  ];
  servicos = [];

  servico: any;
  horariosFuncionamento = [];
  horariosPorDia = {};
  carregando = false;
  private editService: GridHorariosEditService;
  diaAtual: number;

  constructor(
    private empresaService: EmpresasService, private constantsService: ConstantsService,
    private dialogService: DialogService,
    @Inject(GridHorariosEditService) gridHorariosEditService: any
  ) {
    this.editService = gridHorariosEditService();
  }

  ngOnInit() {
    this.diaAtual = new Date().getDay(); // 0 = Domingo, 1 = Segunda, etc.
    this.filtrarServicos();
    this.carregarHorarios();
  }

  filtrarServicos() {
    // Salvar o serviço atual
    const servicoAtual = this.servico;

    // Filtrar serviços baseado nas formas de entrega ativas
    const servicosFiltrados = [];

    // Sempre incluir delivery (site)
    servicosFiltrados.push(this.servicosBase.find((s: any) => s.id === 'site'));

    // Incluir retirada apenas se a forma de entrega retirada estiver ativa
    if (this.temFormaEntregaRetiradaAtiva()) {
      servicosFiltrados.push(this.servicosBase.find((s: any) => s.id === 'siteretirada'));
    }

    // Sempre incluir presencial
    servicosFiltrados.push(this.servicosBase.find((s: any) => s.id === 'presencial'));

    if (this.temIntegracaoIfoodDistribuidaComOrderApi()) {
      servicosFiltrados.push(this.servicosBase.find((s: any) => s.id === 'ifood'));
    }

    this.servicos = servicosFiltrados.filter(Boolean);

    // Tentar manter o serviço selecionado, senão voltar para delivery
    const servicoEncontrado = this.servicos.find(s => s.id === servicoAtual?.id);
    this.servico = servicoEncontrado || this.servicos[0];
  }

  temIntegracaoIfoodDistribuidaComOrderApi(): boolean {
    if (!this.empresa?.integracoesIfood?.length) return false;

    return this.empresa.integracoesIfood.some((integracao: any) =>
      !integracao.desativado &&
      !!integracao.codigoAutorizacao &&
      !!integracao.orderApi
    );
  }

  temFormaEntregaRetiradaAtiva(): boolean {
    if (!this.empresa.formasDeEntrega) return false;

    const formaRetirada = this.empresa.formasDeEntrega.find((forma: any) =>
      forma.formaDeEntrega && forma.formaDeEntrega.nome === 'Retirar'
    );

    return formaRetirada && formaRetirada.ativa;
  }

  ehServicoObrigatorio(servicoId: string): boolean {
    // Apenas delivery (site) é obrigatório
    return servicoId === 'site';
  }

  carregarEmpresaHorarios(){
    this.carregando = true;

    this.constantsService.recarregueEmpresa( (empresa: any) => {
        this.empresa = empresa;
        this.filtrarServicos(); // Recarregar serviços filtrados
        this.carregarHorarios(); // Isso já inclui a ordenação
    });
  }

  ehHoje(dia: number): boolean {
    return dia === this.diaAtual;
  }

  /**
   * Ordena os horários de cada dia por horário de abertura (crescente)
   * Exemplo: 08:00, 14:00, 22:00
   */
  ordenarHorariosPorDia() {
    this.diasDaSemana.forEach(dia => {
      if (this.horariosPorDia[dia.dia] && this.horariosPorDia[dia.dia].length > 0) {
        this.horariosPorDia[dia.dia].sort((a, b) => {
          const horaA = moment(a.horarioAbertura, 'HH:mm:ss');
          const horaB = moment(b.horarioAbertura, 'HH:mm:ss');
          return horaA.diff(horaB);
        });
      }
    });
  }

  carregarHorarios() {
    this.carregando = true;

    // Inicializar estrutura de horários por dia
    this.horariosPorDia = {};
    this.diasDaSemana.forEach(dia => {
      this.horariosPorDia[dia.dia] = [];
    });

    // Carregar horários existentes da empresa
    if (this.empresa.horariosFuncionamento && this.servico) {
      this.empresa.horariosFuncionamento.forEach(horario => {
        if (horario.servico === this.servico.id && horario.funciona) {
          if (!this.horariosPorDia[horario.diaDaSemana]) {
            this.horariosPorDia[horario.diaDaSemana] = [];
          }
          this.horariosPorDia[horario.diaDaSemana].push({
            id: horario.id,
            horarioAbertura: horario.horarioAbertura,
            horarioFechamento: horario.horarioFechamento,
            funciona: horario.funciona
          });
        }
      });
    }

    // Ordenar horários por horário de abertura em cada dia
    this.ordenarHorariosPorDia();

    this.carregando = false;
  }

  temHorariosConfigurados(servico: string){
    return this.empresa.horariosFuncionamento &&
            this.empresa.horariosFuncionamento.find((item: any) => item.servico === servico) != null
  }

  abrirModalAdicionarHorario(diaEspecifico?: number) {
    const windowRef: DialogRef = this.dialogService.open({
      title: 'Adicionar Horário de Funcionamento',
      content: ModalAdicionarHorarioComponent,
      minWidth: 400,
      width: 600,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.servico = this.servico;
    windowRef.content.instance.editService = this.editService;

    // Se foi passado um dia específico, pré-seleciona
    if (diaEspecifico !== undefined) {
      windowRef.content.instance.diasSelecionados = [diaEspecifico];
    }

    windowRef.result.subscribe((result: any) => {
      if (result && result.salvou) {
        this.carregarEmpresaHorarios();
      }
    });
  }

  abrirModalSemana(dia: number) {
    const horariosDoDia = this.getHorariosDoDia(dia);

    if (horariosDoDia.length === 0) {
      // Se não tem horários, abre modal para adicionar
      this.abrirModalAdicionarHorario(dia);
      return;
    }

    // Se tem horários, abre modal para editar todos os horários da semana
    const windowRef: DialogRef = this.dialogService.open({
      title: `Horários da ${this.getDiaSemana(dia)}`,
      content: ModalAdicionarHorarioComponent,
      minWidth: 400,
      width: 600,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.servico = this.servico;
    windowRef.content.instance.editService = this.editService;
    windowRef.content.instance.modoSemana = true;
    windowRef.content.instance.diaSemana = dia;

    windowRef.result.subscribe((result: any) => {
      if (result && result.salvou) {
        this.carregarEmpresaHorarios();
      }
    });
  }

  abrirModalEditarHorario(dia: number, horario: any) {
    const windowRef: DialogRef = this.dialogService.open({
      title: 'Editar Horário de Funcionamento ' + this.servico.label,
      content: ModalAdicionarHorarioComponent,
      minWidth: 400,
      width: 600,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    windowRef.content.instance.empresa = this.empresa;
    windowRef.content.instance.servico = this.servico;
    windowRef.content.instance.horarioParaEditar = horario;
    windowRef.content.instance.diaSelecionado = dia;
    windowRef.content.instance.editService = this.editService;

    windowRef.result.subscribe((result: any) => {
      if (result && result.salvou) {
        this.carregarEmpresaHorarios();
      }
    });
  }

  removerTodosHorarios() {
    const totalHorarios = this.getTotalHorarios();

    if (totalHorarios === 0) {
      alert('Não há horários para remover');
      return;
    }

    // Abrir modal de confirmação Kendo
    const windowRef: DialogRef = this.dialogService.open({
      title: 'Confirmar Remoção',
      content: ModalConfirmacaoComponent,
      width: 500,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    windowRef.content.instance.titulo = `Remover Todos os Horários de ${this.servico.descricao}`;
    windowRef.content.instance.mensagem = `Deseja realmente remover todos os ${totalHorarios} horários cadastrados? Esta ação não pode ser desfeita.`;
    windowRef.content.instance.textoConfirmacao = 'Sim, Remover Todos';
    windowRef.content.instance.textoCancelamento = 'Cancelar';
    windowRef.content.instance.tipoConfirmacao = 'danger';

    windowRef.result.subscribe((result: any) => {
      if (result && result.confirmado) {
        this.executarRemocaoTodosHorarios();
      }
    });
  }

  private executarRemocaoTodosHorarios() {
    this.carregando = true;

    const horarios =
      this.empresa.horariosFuncionamento.filter((item: any) => item.servico === this.servico.id)

    const horarioRemovidos = horarios.map((item: any) => ({id: item.id, removido: true}))

    this.editService.salveHorarios(this.empresa, this.servico, horarioRemovidos).then(() => {
      this.carregando = false;
      this.carregarEmpresaHorarios();
    }).catch(erro => {
      this.carregando = false;
      alert('Erro ao remover horários: ' + erro);
    });

  }

  temHorariosCadastrados(): boolean {
    return this.getTotalHorarios() > 0;
  }

  getTotalHorarios(): number {
    let total = 0;
    this.diasDaSemana.forEach(dia => {
      total += this.getHorariosDoDia(dia.dia).length;
    });
    return total;
  }

  getHorariosDoDia(dia: number) {
    return this.horariosPorDia[dia] || [];
  }

  getDiaSemana(dia: number) {
    const diaObj = this.diasDaSemana.find(d => d.dia === dia);
    return diaObj ? diaObj.descricao : '';
  }

  getAbreviacaoDia(dia: number) {
    const diaObj = this.diasDaSemana.find(d => d.dia === dia);
    return diaObj ? diaObj.abreviacao : '';
  }

  formatarHorario(horario: string) {
    if (!horario) return '';
    return moment(horario, 'HH:mm:ss').format('HH:mm');
  }

  obtenhaTempoAberto(horario: any): string {
    if (!horario || !horario.horarioAbertura || !horario.horarioFechamento) {
      return '';
    }

    // Converter horários para objetos moment
    const abertura = moment(horario.horarioAbertura, 'HH:mm:ss');
    const fechamento = moment(horario.horarioFechamento, 'HH:mm:ss');

    // Se o fechamento é menor que abertura, significa que passa da meia-noite
    if (fechamento.isBefore(abertura)) {
      fechamento.add(1, 'day');
    }

    // Calcular diferença em minutos com precisão
    const diffMinutes = Math.round(fechamento.diff(abertura, 'minutes', true));

    // Converter para horas e minutos
    const horas = Math.floor(diffMinutes / 60);
    const minutos = diffMinutes % 60;

    // Tratar casos especiais de arredondamento
    // Se temos 59 minutos, provavelmente é 1 hora
    if (minutos === 59 && horas >= 0) {
      return `${horas + 1}h`;
    }

    // Se temos 1 minuto e horas > 0, provavelmente é hora exata
    if (minutos === 1 && horas > 0) {
      return `${horas}h`;
    }

    // Formatar o resultado
    if (horas > 0 && minutos > 0) {
      return `${horas}h ${minutos}min`;
    } else if (horas > 0) {
      return `${horas}h`;
    } else if (minutos > 0) {
      return `${minutos}min`;
    } else {
      return '0min';
    }
  }

  alterouSempreReceberPedidos() {
    this.empresaService.atualiseSempreReceberPedidos(this.empresa).then(() => {
    }).catch(() => {
      this.empresa.sempreReceberPedidos = !this.empresa.sempreReceberPedidos;
    });
  }

  selecionouServico(servico: any) {
    this.servico = servico;

    // Se não é obrigatório, mostrar modal de confirmação
    if (!this.ehServicoObrigatorio(servico.id) && !this.temHorariosConfigurados(servico.id)) {
      this.mostrarModalConfiguracaoServico(servico);
      return;
    }

    this.carregarHorarios();
  }

  mostrarModalConfiguracaoServico(servico: any) {
    const windowRef: DialogRef = this.dialogService.open({
      title: `Configurar Horários - ${servico.label}`,
      content: ModalConfirmacaoComponent,
      width: 600,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

   windowRef.content.instance.titulo = ``;
    windowRef.content.instance.mensagem = `
      <p><strong>Deseja configurar horários específicos para ${servico.label}?</strong></p>
      <p>Se você <strong>NÃO configurar</strong> horários específicos para este serviço, o sistema irá:</p>
      <ul>
        <li>Usar automaticamente os horários configurados no <strong>Delivery</strong></li>
        <li>Aplicar as mesmas regras de funcionamento para todos os serviços</li>
      </ul>
      <p>Isso é útil quando você quer que todos os serviços sigam o mesmo horário de funcionamento.</p>
      <p><strong>Recomendação:</strong> Configure horários específicos apenas se precisar de regras diferentes para este serviço.</p>
    `;
    windowRef.content.instance.textoConfirmacao = 'Sim, Configurar Horários Específicos';
    windowRef.content.instance.textoCancelamento = 'Não, Usar Horários do Delivery';
    windowRef.content.instance.tipoConfirmacao = 'info';

    windowRef.result.subscribe((result: any) => {
      if (result && result.confirmado) {
        // Usuário quer configurar horários específicos
        this.carregarHorarios();
      } else {
        // Usuário não quer configurar, voltar para delivery
        this.servico = this.servicos[0];
        this.carregarHorarios();
      }
    });
  }
}
